import { render, staticRenderFns } from "./AppNotice.vue?vue&type=template&id=1ed47956&scoped=true"
import script from "./AppNotice.vue?vue&type=script&lang=js"
export * from "./AppNotice.vue?vue&type=script&lang=js"
import style0 from "./AppNotice.vue?vue&type=style&index=0&id=1ed47956&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed47956",
  null
  
)

export default component.exports